export default {
    buttonRicohDirectDebitApp: 'Go to the App',
    paragraphRicohDirectDebitDemo:
        'For further feature information or demo, please contact us at the address below.',
    paragraphRicohDirectDebitDescription:
        'The Bank Transfer Add-on allows you to create FB data* from invoices inside of MakeLeaps. Using FB data makes it easier to request payments via direct debit.',
    paragraphRicohDirectDebitFootnote:
        '* A bank transfer data format of the Japanese Bankers Association',
    paragraphRicohDirectDebitForm:
        'When applying, please fill in the required items on <0>this application form</0>. (Only available in Japanese)',
    paragraphRicohDirectDebitFormLanguage: '',
    paragraphRicohDirectDebitTrial:
        'Users that have not completed the registration can still access a restricted trial version of the feature.',
    subtitle:
        'Automatically generate account transfer data from Makeleaps invoices.',
    title: 'RICOH Direct Debit',
    titleRicohDirectDebitRegistered: 'Registered users and trial',
};
